'use client'
import { useState, useEffect } from 'react'
import ItemDescModal from './ItemDescModal'

export default function ItemDescModalSSG() {
  const [showModal, setShowModal] = useState(false)
  const [currentItemIndex, setCurrentItemIndex] = useState(null)
  const [description, setDescription] = useState('')

  useEffect(() => {
    const handleClick = (e) => {
      const trigger = e.target.closest('[id^="item-description-btn-ssg"]')
      if (trigger) {
        const index = trigger.id.replace('item-description-btn-ssg', '')
        setCurrentItemIndex(parseInt(index))
        
        // Pre-populate with existing description if available
        const existingTextarea = document.getElementById(`item-description-textarea-ssg${index}`)
        const existingDescription = existingTextarea?.value || ''
        setDescription(existingDescription)
        setShowModal(true)
      }
    }

    document.addEventListener('click', handleClick)
    return () => document.removeEventListener('click', handleClick)
  }, [])

  const updateButtonText = () => {
    if (currentItemIndex !== null) {
      const button = document.getElementById(`item-description-btn-ssg${currentItemIndex}`)
      const textarea = document.getElementById(`item-description-textarea-ssg${currentItemIndex}`)
      
      if (button && textarea) {
        button.textContent = textarea.value ? 'Edit description' : 'Add description'
      }
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    if (currentItemIndex !== null) {
      // Update the visible description preview (first 20-30 characters)
      const previewElement = document.getElementById(`item-description-ssg${currentItemIndex}`)
      const shortDescription = description.length > 30
        ? description.substring(0, 30) + '...'
        : description
      if (previewElement) {
        previewElement.textContent = shortDescription || ''
      }

      // Update the hidden textarea with full description
      const hiddenTextarea = document.getElementById(`item-description-textarea-ssg${currentItemIndex}`)
      if (hiddenTextarea) {
        hiddenTextarea.value = description
        hiddenTextarea.className = "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
      }
    }

    updateButtonText()
    setShowModal(false)
    setCurrentItemIndex(null)
    setDescription('')
  }

  const handleCancel = () => {
    updateButtonText()
    setShowModal(false)
    setCurrentItemIndex(null)
    setDescription('')
  }

  if (!showModal) return null

  const isEditing = description.length > 0

  return <ItemDescModal 
    isEditing={isEditing} 
    handleCancel={handleCancel} 
    handleSubmit={handleSubmit} 
    description={description} 
    setDescription={setDescription} 
  />
}
